<div class="discover-search-container">
  <div class="row justify-content-center">
    <div class="checkbox-filter">
      <achoo-filter-box [options]="discoverFilterBar.countries"
        [(model)]="filterSearch.countries"
        placeholder="{{'discover.search_bar.country_placeholder' | translate}}"
        (openDropDownEvent)="onFilterOpen('countries', tc)"
        (closeDropDownEvent)="onFilterClose($event, 'countries')"
        (selectEvent)="onSelectCountries($event)"
        multiple="true"
        #tc="ngbTooltip"
        placement="bottom"
        ngbTooltip="{{'info_box.discover.country' | translate}}"
        [tooltipBox]="tc" #CountriesList>
      </achoo-filter-box>
    </div>
    <div class="checkbox-filter">
      <achoo-filter-box [options]="discoverFilterBar.genders"
        [(model)]="filterSearch.genders"
        placeholder="{{'discover.search_bar.gender_placeholder' | translate}}"
        (openDropDownEvent)="onFilterOpen('genders', tg)"
        (closeDropDownEvent)="onFilterClose($event, 'genders')"
        #tg="ngbTooltip"
        placement="bottom"
        ngbTooltip="{{'info_box.discover.gender' | translate}}"
        multiple="true"
        [tooltipBox]="tg" #GenderList>
      </achoo-filter-box>
    </div>
    <div class="checkbox-filter">
      <achoo-filter-box #PlatformList
        [options]="discoverFilterBar.platforms"
        [(model)]="filterSearch.platforms"
        placeholder="{{'discover.search_bar.platform_placeholder' | translate}}"
        (openDropDownEvent)="onFilterOpen('platforms', tp)"
        (closeDropDownEvent)="onFilterClose($event, 'platforms')"
        #tp="ngbTooltip"
        placement="bottom"
        ngbTooltip="{{'info_box.discover.platform' | translate}}"
        multiple="true"
        [tooltipBox]="tp">
      </achoo-filter-box>
    </div>
    <div class="checkbox-filter group-filters">
      <div #ActivityFilter class="single-selected with-icon"
           [ngClass]="{'has-selected': hasFilterActivity}"
           actionByLevels="Activity Filter"
           [wallName]="'Basic Filters'"
           [actionData]="eventDataForSegment('Activity Filter')"
           (afterChecking)="onClickActivityFilters($event, ta)"
           #ta="ngbTooltip"
           placement="bottom"
           ngbTooltip="{{'info_box.discover.activity' | translate}}">
        <span class="popup-filter-title" [ngClass]="{'has-selected-filter': hasFilterActivity}">{{'group_details.search_bar.activity' | translate}}</span>
        <img *ngIf="!hasFilterActivity" src="/assets/images/Plus_Dark.svg" class="icon-check">
        <img *ngIf="hasFilterActivity" src="/assets/images/Check_Dark.svg" class="icon-check">
      </div>
      <div class="activity-filters-container" *ngIf="showActivityFilter">
        <activity-filters #activityFilterOnDiscover [filter]="getActivityFilter(filterSearch)"
                          [isActiveDiscoverFollower]="discoverFollowerEnabled"
                          (searchInfluencerByActivityEvent)="searchDiscoverByActivity($event)"
                          (clearActivityFilterEvent)="resetActivityFilters()"
                          (hideActivityFilterEvent)="onHideActivityFilters($event)">
        </activity-filters>
      </div>
    </div>
    <div class="checkbox-filter">
      <project-selection #projectSelection [options]="discoverFilterBar.projects"
                         [allowToModifyProject]="false"
                         [(model)]="filterSearch.projects"
                         [actionData]="eventDataForSegment('Project Filter')"
                         placeholder="{{'discover.search_bar.project_placeholder' | translate}}"
                         (openDropDownEvent)="onFilterOpen('projects', tpro)"
                         (closeDropDownEvent)="onFilterClose($event, 'projects')"
                         #tpro="ngbTooltip"
                         placement="bottom"
                         ngbTooltip="{{'info_box.discover.project' | translate}}"
                         multiple="true"
                         [tooltipBox]="tpro">
      </project-selection>
    </div>
    <div class="checkbox-filter group-filters">
      <div #InterestFilter class="single-selected with-icon" [ngClass]="{'has-selected': hasFilterInterest}"
           (click)="onClickInterestFilters($event, tinter)" #tinter="ngbTooltip" placement="bottom"
           ngbTooltip="{{'info_box.discover.interests' | translate}}">
        <span class="popup-filter-title" [ngClass]="{'has-selected-filter': hasFilterInterest}">{{'discover.search_bar.interests' | translate}}</span>
        <img *ngIf="!hasFilterInterest" src="/assets/images/Plus_Dark.svg" class="icon-check">
        <img *ngIf="hasFilterInterest" src="/assets/images/Check_Dark.svg" class="icon-check">
      </div>
      <div class="activity-filters-container audience" *ngIf="showInterestFilter">
        <interest-filter #interestFilterOnDiscover
                         [discoverFilterBar]="discoverFilterBar"
                         [interestFilter]="selectedInterestFilter"
                         (searchByInterestFilter)="searchDiscoverByInterestFilter($event)"
                         (clearInterestFilterEvent)="resetInterestFilters()"
                         (hideInterestFilterEvent)="onHideInterestFilters($event)">
        </interest-filter>
      </div>
    </div>
    <div class="checkbox-filter group-filters">
      <div #AudienceFilter class="single-selected with-icon"
           [ngClass]="{'has-selected': hasFilterAudience}"
           actionByLevels="Audience Filter"
           [wallName]="'Basic Filters'"
           [actionData]="eventDataForSegment('Audience Filter')"
           (afterChecking)="onClickAudienceFilters($event, tau)"
           #tau="ngbTooltip"
           placement="bottom"
           ngbTooltip="{{'info_box.discover.audience' | translate}}">
        <span class="popup-filter-title" [ngClass]="{'has-selected-filter': hasFilterAudience}">{{'discover.search_bar.audience' | translate}}</span>
        <img *ngIf="!hasFilterAudience" src="/assets/images/Plus_Dark.svg" class="icon-check">
        <img *ngIf="hasFilterAudience" src="/assets/images/Check_Dark.svg" class="icon-check">
      </div>
      <div class="activity-filters-container audience" *ngIf="showAudienceFilter">
        <audience-filter #audienceFilterOnDiscover
                         [audienceSearchCriteria]="selectedAudienceFilter"
                         (searchByAudienceFilter)="searchDiscoverByAudience($event)"
                         (clearAudienceFilterEvent)="resetAudienceFilters()"
                         (hideAudienceFilterEvent)="onHideAudienceFilters($event)">
        </audience-filter>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div class="input-search-field">
      <achoo-text-field placeholder="{{'discover.search_bar.search_input_placeholder' | translate}}"
                        [(model)]="currentInputMention"
                        (keydown)="mentionInputKeyDown($event)"
                        (focusEvent)="onFilterOpen('mention', null)"
                        (focusOutEvent)="onFocusOutMentionInput()"
                        class="input-tag"
                        #mentionInput>
      </achoo-text-field>
    </div>
  </div>
  <div class="row">
      <div class="col-md-12 col-sm-12 keywork-list-container">
        <achoo-chips
          [chips]="filterSearch.mentions"
          [editable]="true"
          (deleteItem)="onDeleteMention($event)"
        ></achoo-chips>
      </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/discover/discover-search/discover-search.component.html